import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { APIGeneratorModal } from '../../../components/ApiKeyManagement/APIGeneratorModal';
import { APIKeyTransferModal } from '../../../components/ApiKeyManagement/APIKeyTransferModal';
import { Heading } from '../../../components/Heading';
import { TertiaryNavigation } from '../../../components/TertiaryNavigation/TertiaryNavigation';
import { useApiKeys } from '../../../hooks/queries';
import { TertiaryFeature } from '../../../utils/types';
import { APIKeyHistory } from '../APIKeyHistory/APIKeyHistory';
import { APIKeyOverview } from '../APIKeyOverview/APIKeyOverview';
import { useNavigationContext } from '../../../context/NavigationProvider';

export const APIKeyManagement: React.FC = () => {
  const { secondaryFeature } = useNavigationContext();
  const { t } = useTranslation();
  const [showAPIGeneratorModal, setShowAPIGeneratorModal] = useState(false);
  const {
    areAvailableKeysLoading,
    apiKeys,
    apiHistory,
    isApiKeyHistoryLoading,
  } = useApiKeys();

  const onCancel = () => {
    setShowAPIGeneratorModal(false);
  };

  return (
    <>
      <div className="max-w-xl-content xl:min-w-content mx-auto mb-7 space-y-5 md:mb-9">
        <div className="mb-5 mt-6" data-test="page-header">
          <Heading
            text={t('features:collaboration:api-management:heading')}
            margin={0}
            level="h2"
          />
        </div>
        <div className="space-y-4">
          <div className="text-grey-700 mt-1 w-3/4 font-bold ">
            {t(`features:collaboration:api-management:description1`)}
          </div>
          <div className="text-grey-700 mt-1 w-3/4 ">
            {t(`features:collaboration:api-management:description2`)}
          </div>
        </div>

        <TertiaryNavigation>
          {secondaryFeature?.tertiaryFeatures?.find(
            ({ id }) =>
              id === TertiaryFeature.COLLABORATION_API_MANAGEMENT_KEY_OVERVIEW,
          ) && (
            <TertiaryNavigation.Item
              id={TertiaryFeature.COLLABORATION_API_MANAGEMENT_KEY_OVERVIEW}
            >
              <APIKeyOverview
                areAvailableKeysLoading={areAvailableKeysLoading}
                apiKeys={apiKeys}
                handleShowAPIGeneratorModal={() =>
                  setShowAPIGeneratorModal(true)
                }
                module="api-management"
                tab="keyOverview"
              />
            </TertiaryNavigation.Item>
          )}
          {secondaryFeature?.tertiaryFeatures?.find(
            ({ id }) =>
              id === TertiaryFeature.COLLABORATION_API_MANAGEMENT_KEY_HISTORY,
          ) && (
            <TertiaryNavigation.Item
              id={TertiaryFeature.COLLABORATION_API_MANAGEMENT_KEY_HISTORY}
            >
              <APIKeyHistory
                module="api-management"
                apiHistory={apiHistory}
                isApiKeyHistoryLoading={isApiKeyHistoryLoading}
              />
            </TertiaryNavigation.Item>
          )}
        </TertiaryNavigation>
      </div>
      {showAPIGeneratorModal && (
        <APIGeneratorModal
          onCancel={onCancel}
          onConfirmAPICopy={() => setShowAPIGeneratorModal(false)}
        />
      )}
      <APIKeyTransferModal />
    </>
  );
};
